import classNames from 'classnames';
import React from 'react';
import Style from 'styles/components/func.module.scss';
import FuncSectionBlock from 'components/FuncSectionBlock';
import PcImg from 'images/firstview/pc.png';
import about from 'images/func/about.png';
import faq from 'images/func/faq.png';
import news from 'images/func/news.png';
import storeInfo from 'images/func/storeInfo.png';
import designTmp from 'images/func/designTmp.png';
import freePage from 'images/func/freePage.png';
import payment from 'images/func/payment.png';
import delivery from 'images/func/delivery.png';
import productRegisterImage from 'images/func/productRegisterImage.png';
import productCategoryImage from 'images/func/productCategoryImage.png';
import productVariationImage from 'images/func/productVariationImage.png';
import productPeriodImage from 'images/func/productPeriodImage.png';
import memberPriceImage from 'images/func/memberPriceImage.png';
import privatePublishImage from 'images/func/privatePublishImage.png';
import ageLimitImage from 'images/func/ageLimitImage.png';
import giftSettingImage from 'images/func/giftSettingImage.png';
import bulkPurchaseImage from 'images/func/bulkPurchaseImage.png';
import pointImage from 'images/func/pointImage.png';
import pointSaleImage from 'images/func/pointSaleImage.png';
import timeSaleImage from 'images/func/timeSaleImage.png';
import couponImage from 'images/func/couponImage.png';
import mailMagazineImage from 'images/func/mailMagazineImage.png';
import dashboardImage from 'images/func/dashboardImage.png';
import reviewImage from 'images/func/reviewImage.png';
import secretSiteImage from 'images/func/secretSiteImage.png';
import handDeliveryImage from 'images/func/handDeliveryImage.png';
import orderDataDownloadImage from 'images/func/orderDataDownloadImage.png';
import bulkProductUploadImage from 'images/func/bulkProductUploadImage.png';
import paymentMethod from 'images/func/paymentMethod.png';

const TopView = () => {
  return (
    <section className={Style.func}>
      <div className={Style.func__topView}>
        <div className={Style.func__topView__label}>
          基本機能はしっかり使える<br />
          必要な機能はあとから追加
        </div>
        <img className = {classNames(Style.func__topView__img)} src={PcImg} alt="" />
      </div>
    </section>
  );
}

const shopFeatures = [
  {
    title: 'デザインテンプレート',
    description: 'HTML・CSSの知識がなくても、簡単にショップデザインをつくれます。',
    image: designTmp
  },
  {
    title: 'フリーページ',
    description: 'パーツをお好みに組み合わせて、オリジナルページが作成できます。',
    image: freePage
  },
  {
    title: '配送設定',
    description: '配送方法ごとにサイズ別や地域別に配送料の設定ができます。',
    image: delivery
  },
  {
    title: '決済設定',
    description: '銀行振込や代引き、クレジットカード決済などの決済手段を登録できます。詳しくは、ページ下部をご覧ください。',
    image: payment
  },
  {
    title: 'NEWS機能',
    description: 'ショップの最新情報(お知らせ)を発信できます。',
    image: news
  },
  {
    title: 'FAQ管理',
    description: 'お客様からのよくある質問(FAQ)を作成することができます。',
    image: faq
  },
  {
    title: 'ABOUTページ',
    description: 'お店の紹介や商品・サービスに込める想いなどを伝えるページを作成できます。',
    image: about
  },
  {
    title: 'お店情報',
    description: '特定商取引法や問い合わせ先など、テキストを入力するだけで、ショップ運営に必要なページが設定できます。',
    image: storeInfo
  },
  {
    title: '独自ドメイン設定',
    description: '独自ドメインを設定することで、ショップのURLを自由にカスタマイズできます。※ドメイン取得費用、更新費用などはご負担いただきます。詳細はお問い合わせください。',
    image: storeInfo
  },
];

const productSetup = [
  {
    title: '商品登録',
    description: '商品名や販売価格などを入力するだけで簡単に登録できます。',
    image: productRegisterImage
  },
  {
    title: '商品カテゴリ',
    description: '登録した商品をカテゴリに分けて表示できます。',
    image: productCategoryImage
  },
  {
    title: 'バリエーション',
    description: '色やサイズなどを設定し、商品の選択肢を登録できます。',
    image: productVariationImage
  },
  {
    title: '予約/販売期間',
    description: '商品の予約販売や、販売期間の設定ができます。',
    image: productPeriodImage
  },
  {
    title: '会員限定価格',
    description: '商品ごとにショップの会員限定の販売価格を設定できます。',
    image: memberPriceImage
  },
  {
    title: '限定公開',
    description: '商品の専用URLを知っているお客様にのみ、商品情報を公開することができます。',
    image: privatePublishImage
  },
  {
    title: '年齢制限',
    description: '商品ごとに15歳以上、18歳以上、20歳以上の年齢制限をかけることができます。',
    image: ageLimitImage
  },
  {
    title: 'ギフト設定',
    description: '複数のギフトラッピングの種類や価格を設定することができます。',
    image: giftSettingImage
  },
  {
    title: '定期購入設定',
    description: '商品の定期購入を設定できます。',
    image: productPeriodImage
  },
  {
    title: '販売開始通知',
    description: '商品の販売開始日を設定すると、その日時に通知メールが送信されます。',
    image: news
  },
];

const marketingFeatures = [
  {
    title: 'まとめ買い',
    description: '同一商品を複数個購入した際に割引されるように設定できます。',
    image: bulkPurchaseImage,
  },
  {
    title: 'ポイント',
    description: '商品ごとにポイント付与率を設定することができます。',
    image: pointImage,
  },
  {
    title: 'ポイントセール',
    description: '通常ポイントに追加してポイントを付与することができます。',
    image: pointSaleImage,
  },
  {
    title: 'タイムセール',
    description: '開始・終了日を設定し、割引率(%)を適用することができます。',
    image: timeSaleImage,
  },
  {
    title: 'クーポン',
    description: '会員に割引(%)・値引き(円)クーポンを配布することができます。',
    image: couponImage,
  },
  {
    title: 'メルマガ',
    description: 'タイムセールや新商品の入荷などのメールマガジン（メルマガ）を配信することができます。',
    image: mailMagazineImage,
  },
  {
    title: 'ダッシュボード',
    description: '売上・注文数・平均単価を、月や週などの期間別に確認することができます。',
    image: dashboardImage,
  },
  {
    title: 'レビュー',
    description: '購入者様が、購入した商品の評価・コメントを付けることができます。',
    image: reviewImage,
  },
  {
    title: 'Google自動フィード設定',
    description: 'ショップの商品情報を自動連携し、ショッピング広告や無料リスティングの表示を最新に保つ事ができます。',
    image: dashboardImage,
  },
  {
    title: 'Googleタグマネージャー連携',
    description: '管理画面でGoogleタグマネージャーを簡単に連携する事ができます。',
    image: dashboardImage,
  },
  {
    title: 'Googleサーチコンソール連携',
    description: '管理画面でGoogleサーチコンソールを簡単に連携する事ができます。',
    image: dashboardImage,
  },
  {
    title: 'SNS設定',
    description: 'Instagram、X（旧:Twitter）、Facebookの設定ができます。',
    image: reviewImage,
  },
  {
    title: 'TikTok商品投稿',
    description: 'TikTokに商品情報を自動的に投稿する設定ができます。',
    image: reviewImage,
  },
  {
    title: 'Instagramショップ開設サポート',
    description: 'Instagramショップ開設をサポートいたします。',
    image: reviewImage,
  },
];

const comachiApps = [
  {
    title: 'シークレットサイト',
    description: 'シークレット会員に登録した人だけがショップを閲覧できるように設定することができます。',
    image: secretSiteImage,
  },
  {
    title: '手渡し',
    description: '商品を購入者へ直接手渡しする商品を登録が可能です。',
    image: handDeliveryImage,
  },
  {
    title: '注文データダウンロード',
    description: '注文データをExcelまたはCSV形式でダウンロードすることができます。',
    image: orderDataDownloadImage,
  },
  {
    title: '商品一括登録',
    description: 'CSVファイルに入力した商品情報を一括で登録することができます。',
    image: bulkProductUploadImage,
  }
];

const appsDescreption = "ショップの運営に合わせて、必要なアプリ（一部有料）を追加できます。";

const PaymentMethod = () => {
  return (
    <>
      <section className={Style.storefunc}>
        <div className={Style.paymentMethod} >
          <h2 className={Style.title}>決済手段</h2>
          <img src={paymentMethod} className={Style.paymentMethod__img} alt="決済手段" />
          <div className={Style.paymentMethod__notes}>
            ※クレジットカード決済は「株式会社ゼウス」のサービスです。<br />
            ※PayPay決済は「GMOイプシロン株式会社」のサービスです。<br />
            ※その他、ご利用になられる決済手段に応じて、各決済サービスを提供する会社へお申込みをしていただく必要がございます。
          </div>
        </div>
      </section>
    </>
  );
};


const Func = () => {
  return (
    <>
      <TopView />
      <FuncSectionBlock title="お店づくり" items={shopFeatures} />
      <FuncSectionBlock title="商品の準備" items={productSetup} />
      <FuncSectionBlock title="商品を売る" items={marketingFeatures} />
      <PaymentMethod />
      <FuncSectionBlock title="アプリ" items={comachiApps} subTitle={appsDescreption}/>
    </>
  );
};

export default Func;
